import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, ShieldCheck } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

import logo3c from "@/assets/logo-3c-jatim.jpg";

const LINKS = [
  { to: "/", label: "Beranda", testid: "nav-link-beranda", end: true },
  { to: "/#profil", label: "Profil", testid: "nav-link-profil" },
  { to: "/berita", label: "Berita", testid: "nav-link-berita" },
  { to: "/event", label: "Event", testid: "nav-link-event" },
  { to: "/galeri", label: "Galeri", testid: "nav-link-galeri" },
  { to: "/#kontak", label: "Kontak", testid: "nav-link-kontak" },
];

export const Brand = () => {
  const navigate = useNavigate();

  const handleDoubleClick = (e) => {
    e.preventDefault();
    toast.success("Pintu Rahasia Admin Terbuka! 🔑", { duration: 3000 });
    navigate("/admin/login");
  };

  return (
    <div
      onDoubleClick={handleDoubleClick}
      title="Tips: Double click logo 2x untuk pintu rahasia Login Admin"
      className="cursor-pointer select-none"
    >
      <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-3 group">
        <img
          src={logo3c}
          alt="Logo 3C Jatim"
          className="h-10 w-10 rounded-full object-cover border border-white/20 shadow-md shadow-rose-600/30 transition-transform duration-300 group-hover:scale-110"
        />
        <span className="font-heading text-2xl font-bold uppercase tracking-wide text-white">
          3C<span className="text-rose-500">-</span>JATIM
        </span>
      </Link>
    </div>
  );
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors duration-200 hover:text-rose-400 ${isActive ? "text-rose-400" : "text-slate-300"}`;

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#090A0F]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
        <Brand />
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) =>
            l.to.includes("#") ? (
              <Link key={l.testid} to={l.to} data-testid={l.testid} className="text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-rose-400">
                {l.label}
              </Link>
            ) : (
              <NavLink key={l.testid} to={l.to} end={l.end} data-testid={l.testid} className={linkCls}>
                {l.label}
              </NavLink>
            )
          )}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <Link to="/admin/login" data-testid="nav-link-admin-login" title="Login Pengurus"
            className="grid h-9 w-9 place-items-center rounded-md border border-white/10 text-slate-400 transition-colors hover:border-rose-500/40 hover:text-rose-400">
            <ShieldCheck className="h-4 w-4" />
          </Link>
          <Link to="/gabung" data-testid="nav-link-pendaftaran">
            <Button className="bg-rose-600 font-semibold text-white shadow-lg shadow-rose-600/30 transition-all duration-300 hover:-translate-y-0.5 hover:bg-rose-500 hover:shadow-rose-500/50">
              Gabung Sekarang
            </Button>
          </Link>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button data-testid="nav-mobile-menu-button" className="grid h-10 w-10 place-items-center rounded-md border border-white/10 text-slate-200 lg:hidden">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72 border-white/10 bg-[#11131F]">
            <SheetTitle className="sr-only">Menu Navigasi</SheetTitle>
            <div className="mt-8 flex flex-col gap-5">
              {LINKS.map((l) => (
                <Link key={l.testid} to={l.to} onClick={() => setOpen(false)}
                  className="font-heading text-xl font-semibold uppercase tracking-wide text-slate-200 hover:text-rose-400">
                  {l.label}
                </Link>
              ))}
              <Link to="/gabung" onClick={() => setOpen(false)}>
                <Button className="mt-2 w-full bg-rose-600 font-semibold text-white hover:bg-rose-500">Gabung Sekarang</Button>
              </Link>
              <Link to="/admin/login" onClick={() => setOpen(false)} className="text-sm text-slate-400 hover:text-rose-400">
                Login Pengurus
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
